import { css } from 'styled-components';
import { media } from '../../theme/mixins/responsive';
export const STYLED_RESPONSIVE_BREAKPOINTS = [
    'ultra',
    'wide',
    'xxl',
    'xl',
    'l',
    'md',
    'tablet',
    'mobile',
];
const getMediaQueriesStyling = (props) => {
    const { $default, $ultra, $wide, $xxl, $xl, $l, $md, $mobile, $tablet } = props;
    return css `
    ${$default};
    ${$ultra ? media.ultra `${$ultra}` : undefined};
    ${$wide ? media.wide `${$wide}` : undefined};
    ${$xxl ? media.xxl `${$xxl}` : undefined};
    ${$xl ? media.xl `${$xl}` : undefined};
    ${$l ? media.l `${$l}` : undefined};
    ${$md ? media.md `${$md}` : undefined};
    ${$tablet ? media.tablet `${$tablet}` : undefined};
    ${$mobile ? media.mobile `${$mobile}` : undefined};
  `;
};
export default getMediaQueriesStyling;
